import { render } from "./FooterPart.vue?vue&type=template&id=d9d881ae&scoped=true"
import script from "./FooterPart.vue?vue&type=script&lang=js"
export * from "./FooterPart.vue?vue&type=script&lang=js"

import "./FooterPart.vue?vue&type=style&index=0&id=d9d881ae&scoped=true&lang=css"

import exportComponent from "/Users/robertprikryl/smartAIm/unity_media/vue-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9d881ae"]])

export default __exports__